
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "whats-new-in-apache-atlas-21"
    }}>{`What's new in Apache Atlas 2.1?`}</h1>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Quick Search`}</strong>{`: provides a simpler search experience with type-ahead suggestions`}</li>
      <li parentName="ul"><strong parentName="li">{`Business Metadata`}</strong>{`: enables augmenting entity-types with additional attributes, search entities using these attributes`}</li>
      <li parentName="ul"><strong parentName="li">{`Labels`}</strong>{`: ability to add/remove labels on entities, and search entities using labels`}</li>
      <li parentName="ul"><strong parentName="li">{`Custom Attributes`}</strong>{`: ability to add entity instance specific custom attributes i.e. attributes not defined in entity-def or business metadata`}</li>
      <li parentName="ul"><strong parentName="li">{`Entity Purge`}</strong>{`: added REST APIs to purge deleted entities`}</li>
    </ul>
    <h2 {...{
      "id": "enhancements"
    }}>{`Enhancements`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Search`}</strong>{`: ability to find entities by more than one classification`}</li>
      <li parentName="ul"><strong parentName="li">{`Performance`}</strong>{`: improvements in lineage retrieval and classification-propagation`}</li>
      <li parentName="ul"><strong parentName="li">{`Notification`}</strong>{`: ability to process notifications from multiple Kafka topics`}</li>
      <li parentName="ul"><strong parentName="li">{`Hive Hook`}</strong>{`: tracks process-executions via hive_process_execution entities`}</li>
      <li parentName="ul"><strong parentName="li">{`Hive Hook`}</strong>{`: captures DDL operations via hive_db_ddl and hive_table_ddl entities`}</li>
      <li parentName="ul"><strong parentName="li">{`Notification`}</strong>{`: introduced shell entities to record references to non-existing entities in notifications`}</li>
      <li parentName="ul"><strong parentName="li">{`Spark`}</strong>{`: added model to capture Spark entities, processes and relationships`}</li>
      <li parentName="ul"><strong parentName="li">{`AWS S3`}</strong>{`: introduced updated model to capture AWS S3 entities and relationships`}</li>
      <li parentName="ul"><strong parentName="li">{`ADLS-Gen2`}</strong>{`: introduced model to capture Azure Data Lake Storage Gen2 entities and relationships`}</li>
      <li parentName="ul"><strong parentName="li">{`Dependencies`}</strong>{`: JanusGraph 0.5.1, Tinkerpop 3.4.6, Spring Framework 4.3.20`}</li>
      <li parentName="ul"><strong parentName="li">{`Authorization`}</strong>{`: updated to cover new features, like: business metadata, labels, purge`}</li>
      <li parentName="ul"><strong parentName="li">{`UI`}</strong>{`: multiple UI improvements, including a beta UI`}</li>
      <li parentName="ul">
        <a href="https://issues.apache.org/jira/issues/?jql=project%20%3D%20ATLAS%20AND%20status%20%3D%20Resolved%20AND%20fixVersion%20%3D%202.1.0%20ORDER%20BY%20updated%20DESC%2C%20priority%20DESC">List of JIRAs resolved in Apache Atlas 2.1.0</a>
      </li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;